import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const DELETE_FILTERING_RULE: TypedDocumentNode<Data, Variables> = gql`
  mutation deleteFilteringRule($input: DeleteFilteringRuleInput!) {
    deleteFilteringRule(input: $input) {
      errors {
        attribute
        message
      }
    }
  }
`
